/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { CloseIcon, ImageIcon } from 'assets/icons';
import { CurrencyInput, Select } from 'components';
import { Globals } from 'utils';
import { BannerService } from 'services';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

interface ModalCreateBannerProps {
  banner?: any
  onClose: (reload?: boolean) => void
}

const ModalCreateBanner = ({ banner, onClose }: ModalCreateBannerProps) => {

  const [form, setForm] = useState({
    banner_id: '',
    photo: '',
    photo_blob: '',
    time_id: '',
    position_id: '',
    cost: '',
    hasFile: true,
  });
  const [times, setTimes] = useState([]);
  const [positions, setPositions] = useState([]);

  const getSelects = async () => {
    const toSelect = (data: any) => data?.map((x: any) => ({ value: x.id, label: x.name })) ?? [];

    try {
      const res: any = await BannerService.getSelects();
      setTimes(toSelect(res?.times));
      setPositions(toSelect(res?.positions));

    } catch (error) {
      
    }
  }

  const onChange = (value: string | File, target: keyof typeof form) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const validateForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!form.photo)
      return Globals.showError('Debe subir una foto');

    if (!form.time_id)
      return Globals.showError('Debe ingresar el tiempo');

    if (!form.position_id)
      return Globals.showError('Debe ingresar el área de publicación');

    if (!form.cost)
      return Globals.showError('Debe ingresar el costo');

    onSubmit();
  }

  const onSubmit = async () => {
    try {
      await BannerService.create(form);
      Globals.showSuccess('Banner creado con éxito');
      onClose(true);

    } catch (error: any) {
      const message = error?.response?.data?.error || error?.response?.error || 'Ocurrió un error inesperado';
      Globals.showError(message);
    }
  }

  useEffect(() => {
    setForm({
      banner_id: banner?.id,
      photo: banner?.photo,
      photo_blob: banner?.photo ? Globals.fromPhotos(banner.photo) : '',
      time_id: banner?.time_id,
      position_id: banner?.position_id,
      cost: banner?.cost,
      hasFile: true,
    });
    getSelects();
  }, []);

  return (
    <form onSubmit={validateForm}>
      <header>
        <p className="title">Nuevo Banner</p>
        <button type="button" className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <section className="head">
        <label className="banner-photo">
          {form.photo ? (
            <img src={form.photo_blob} alt="Usuario" />
          ) : (
            <img className="banner-icon" src={ImageIcon} alt="Usuario" />
          )}
          <input
            type="file"
            hidden
            onChange={e => {
              if (e?.target?.files?.length) {
                onChange(e?.target?.files[0], 'photo');
                onChange(URL.createObjectURL(e?.target?.files[0]), 'photo_blob');
                e.target.value = '';
              }
            }}
          />
        </label>
        <div className="photo-info">
          <label>Subir imagen</label>
          <p>La medida del banner debe ser de 750px por 406px en formato JPG, con un peso máximo de 300KB</p>
        </div>
      </section>

      <section className="body">
        <Select
          label="Tiempo"
          name="time_id"
          value={form.time_id}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'time_id')}
          options={times}
        />
        <Select
          label="Área a publicar"
          name="position_id"
          value={form.position_id}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'position_id')}
          options={positions}
        />
        <CurrencyInput
          label="Costo"
          className="cost"
          placeholder="0,00"
          value={form.cost}
          onValueChange={v => onChange(String(v), 'cost')}
        />
      </section>

      <div className="actions">
        <button>Guardar</button>
      </div>
    </form>
  );
}

export default ModalCreateBanner;